import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useTheme, SPACING, TYPOGRAPHY } from '../../theme';
import { EVALUATION_STATUS_META } from '../../constants/evaluationStatus';
import { formatRelativeTime } from '../../utils/time';
import { EvaluationStatus, Timestamp } from '../../types';

interface EvaluationStatusPillProps {
  status: EvaluationStatus;
  at?: Timestamp;
}

/**
 * Quiet line under OwnerStrip reporting the last "Notify my agent" send —
 * a record of what the owner told their agent, not a live state (the agent
 * doesn't write it back).
 */
export function EvaluationStatusPill({ status, at }: EvaluationStatusPillProps) {
  const { colors } = useTheme();
  const relative = formatRelativeTime(at, { suffix: 'ago' });
  const label = EVALUATION_STATUS_META[status].label;

  return (
    <View style={styles.container} testID="structure-evaluation-status">
      <Text style={[styles.text, { color: colors.textSecondary }]}>
        Agent notified: {label}
        {relative ? `, ${relative}` : ''}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: SPACING.xs,
  },
  text: {
    ...TYPOGRAPHY.bodySmall,
  },
});
